import { QueryCache, VueQueryPlugin } from '@tanstack/vue-query'
import PortalVue from 'portal-vue'
import { i18n } from '@/plugins/i18n'
import deepUiLib from './deep-ui-lib'
import './deep-libs'
import { getRouter } from '@/plugins/router'
import { sentry } from '@/plugins/sentry'
import fontawesome from './fontawesome'
import vuetify from './vuetify'
import type { App } from 'vue'

export function registerPlugins(app: App) {
  app.use(vuetify)
  app.use(i18n)
  app.use(sentry)
  app.use(fontawesome)
  app.use(PortalVue)
  app.use(VueQueryPlugin, {
    queryClientConfig: {
      defaultOptions: {
        queries: {
          refetchOnWindowFocus: false,
          retry: false,
        },
      },
      queryCache: new QueryCache({
        onError: (error) =>
          console.error(`Something went wrong: ${error.message}`),
      }),
    },
    enableDevtoolsV6Plugin: true,
  })
  app.use(deepUiLib)

  // Init router after all other plugins
  // https://github.com/dsb-norge/vue-keycloak-js/issues/94#issuecomment-1794403391
  // https://github.com/keycloak/keycloak/issues/14742#issuecomment-1663069438
  app.use(getRouter())
}
